// extracted by mini-css-extract-plugin
export default {"navbarLogo":"Navbar_navbarLogo__ilid9","main":"Navbar_main__lZmD5","cf":"Navbar_cf__+gBXg","menu":"Navbar_menu__O-y2t","submenu":"Navbar_submenu__i16j4"};